import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prCustomManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  prCustomManageForecastTreeData: [],
  prCustomManageForecastFinalTreeData: [],
};

const PRCustomManageScreenRedux = createSlice({
  name: "PRCustomManageScreenRedux",
  initialState,
  reducers: {
    setPRCustomManageForecastBottlerData: (state, action) => {
      state.prCustomManageForecastBottlerData = action.payload;
    },
    setPRCustomManageForecastTreeData: (state, action) => {
      state.prCustomManageForecastTreeData = action.payload;
    },
    setPRCustomManageForecastFinalTreeData: (state, action) => {
      state.prCustomManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setPRCustomManageForecastBottlerData,
  setPRCustomManageForecastTreeData,
  setPRCustomManageForecastFinalTreeData,
} = PRCustomManageScreenRedux.actions;
export default PRCustomManageScreenRedux.reducer;
